var map = {
	"./1spin4win.svg": 86509,
	"./1spin4winv3.svg": 38280,
	"./1x2-gaming.svg": 14637,
	"./1x2gaming.svg": 64698,
	"./1x2gamingv4.png": 86548,
	"./3oaks.svg": 76011,
	"./3oaksv3.svg": 16222,
	"./3oaksv4.png": 10905,
	"./5men.svg": 83261,
	"./7mojos.svg": 97203,
	"./Amigo Gaming.png": 49180,
	"./Amusnet.png": 4421,
	"./BetGames.png": 10426,
	"./BetSolutions.svg": 27549,
	"./Betsoft.png": 72275,
	"./BiGTimeGaming.png": 34936,
	"./Blue favicon_nfs_0d02cc90-7b7f-47da-a371-aa9d47c16f93.svg": 60892,
	"./BluePrint.png": 39767,
	"./Booming Games.png": 36588,
	"./CT Gaming - Casino Technology.webp": 9954,
	"./Caleta.png": 63600,
	"./Concept Gaming.png": 26347,
	"./Elk Studios.png": 47801,
	"./Felix.svg": 40600,
	"./Felixgaming_nfs_7e70597f-b843-4721-8352-6493206f8946.svg": 60158,
	"./FlatDog Games.png": 47222,
	"./Freshdeck.svg": 60841,
	"./Gamomat_nfs_dd4394f2-7611-4403-8eb8-ba8116b8b631.svg": 40425,
	"./Gamomat_nfs_dd4394f2-7611-4403-8eb8-ba8116b8b631v2.png": 51531,
	"./Genii.png": 37090,
	"./Habanero_nfs_ad857600-bdd0-42e2-8c24-f9695a03b4b2.svg": 45771,
	"./Habanero_nfs_ad857600-bdd0-42e2-8c24-f9695a03b4b2v3.png": 55530,
	"./Jacktop-Live.svg": 3091,
	"./Mancala Games.svg": 8574,
	"./Mascot Gaming.png": 57970,
	"./Micorgaming.png": 19727,
	"./NOVOMATIC.png": 45172,
	"./Netent_nfs_40b8d62b-16b7-4307-9a08-58f642b61681.svg": 62296,
	"./Netent_nfs_40b8d62b-16b7-4307-9a08-58f642b61681v2.png": 41528,
	"./Netgaming.png": 92128,
	"./Playtech.png": 68158,
	"./PushGaming_nfs_37c535dc-a01a-4fa8-8ca6-969d7d1d6567.svg": 225,
	"./PushGaming_nfs_37c535dc-a01a-4fa8-8ca6-969d7d1d6567v2.png": 4609,
	"./RAWGaming_nfs_8462bc91-965d-40d0-9f55-ab621b609d3f.svg": 4666,
	"./Red Rake.png": 4076,
	"./Redtiger_nfs_45c9608f-bafc-482b-a74b-16a017f3493e.svg": 10098,
	"./Redtiger_nfs_45c9608f-bafc-482b-a74b-16a017f3493ev3.png": 867,
	"./Relax Gaming.png": 96989,
	"./Revolver.png": 9909,
	"./SA_Gaming.svg": 70506,
	"./Salsa.png": 71098,
	"./Skywind.png": 27107,
	"./Slotopia.svg": 88573,
	"./Smartsoft.png": 78453,
	"./Spearhead.png": 68287,
	"./StakeLogic.png": 58888,
	"./TaDa-gamming.png": 7629,
	"./Thunderspin.png": 73408,
	"./Tom Horn.png": 96451,
	"./Triple Cherry.png": 68189,
	"./VIVO Gaming.png": 75863,
	"./alg.svg": 68500,
	"./amatic.svg": 66071,
	"./amaticv4.png": 56967,
	"./apollo-games.png": 60515,
	"./avatarux.svg": 25702,
	"./avataruxv4.png": 97598,
	"./aviatrix.png": 24466,
	"./belatra.svg": 52711,
	"./belatrav4.png": 33513,
	"./betsoft.avif": 41351,
	"./bgaming.avif": 96195,
	"./bgaming.svg": 86459,
	"./bgamingv3.svg": 43310,
	"./bgamingv5.png": 26552,
	"./bigtimegaming.avif": 19094,
	"./blueprint.avif": 85819,
	"./booming.avif": 93105,
	"./booming.svg": 92433,
	"./boomingv3.svg": 77188,
	"./booongo_nfs_b58d7ef1-f8fc-486f-8d4b-5cb242af1836.svg": 49888,
	"./bsg-min_nfs_cf657b5d-36ac-4873-95de-e0c0f585cff0_nfs_908dba4a-065d-461f-b601-328c9f6b12c6.svg": 14967,
	"./bsg.svg": 30602,
	"./btg_nfs_67dc1e65-0fc4-480d-af18-0973a0a554b9.svg": 56730,
	"./egt.svg": 86518,
	"./egtv3.svg": 50639,
	"./el-casino.webp": 701,
	"./endorphina.svg": 57948,
	"./endorphinav3.svg": 33701,
	"./endorphinav4.png": 29496,
	"./evolution-new.svg": 42956,
	"./evolution.avif": 16953,
	"./evolution.svg": 26265,
	"./evolutionv3.png": 35204,
	"./evoplay.svg": 95160,
	"./evoplayv3.svg": 65529,
	"./evoplayv4.png": 65026,
	"./ezugi.svg": 86496,
	"./ezugiv3.webp": 95551,
	"./fantasma.svg": 86573,
	"./fantasmav4.png": 50953,
	"./fugaso_nfs_f380d996-359a-4132-bb35-3cb3174c1c92.svg": 70728,
	"./fugaso_nfs_f380d996-359a-4132-bb35-3cb3174c1c92v2.png": 98800,
	"./gameart.svg": 71163,
	"./gameartv4.png": 73869,
	"./gamebeat.svg": 95728,
	"./gamebeatv3.png": 4563,
	"./gamingcorps.svg": 77032,
	"./gamzix.svg": 77776,
	"./gamzixv3.svg": 84465,
	"./gamzixv4.png": 96688,
	"./goldenrace.png": 36724,
	"./groove.svg": 95584,
	"./hacksaw.avif": 62018,
	"./hacksaw.svg": 43776,
	"./hacksawv3.svg": 94945,
	"./hacksawv5.png": 10187,
	"./hollegames.svg": 93023,
	"./iconic21.svg": 65238,
	"./iconic21_Color.svg": 83594,
	"./igrosoft.svg": 63475,
	"./in-out.svg": 84864,
	"./infin.svg": 43554,
	"./irondog.webp": 62738,
	"./isoftBet.png": 63438,
	"./jaderabbit.svg": 31284,
	"./kagaming.svg": 4185,
	"./kagamingv3.png": 54674,
	"./kalamba games GJ.png": 85875,
	"./kalamba-games.svg": 77757,
	"./kalamba.svg": 73667,
	"./lucky.svg": 20838,
	"./luckystreak_nfs_871a9e3d-805f-4e68-bead-90912dbcdd27.svg": 86560,
	"./mancala.svg": 49295,
	"./mancalav3.png": 16582,
	"./mascot.svg": 55375,
	"./microgaming.avif": 88377,
	"./mrslotty.svg": 55426,
	"./netent.avif": 30772,
	"./netgame.svg": 37393,
	"./netgamev3.svg": 57668,
	"./netgamev5.png": 33726,
	"./nolimit.svg": 83956,
	"./nolimitcity.avif": 53753,
	"./nolimitv3.svg": 27261,
	"./nolimitv4.png": 78774,
	"./novomatic.svg": 25640,
	"./nucleus.svg": 38789,
	"./onetouch.avif": 72003,
	"./onlyplay.svg": 75742,
	"./onlyplayv4.png": 33730,
	"./peterandsons.avif": 74358,
	"./pgsoft.avif": 24801,
	"./pgsoft.svg": 55457,
	"./pgsoftv3.png": 79054,
	"./platipus.avif": 88244,
	"./platipus.svg": 9322,
	"./platipusv3.svg": 11003,
	"./platipusv5.png": 41519,
	"./playngo.svg": 5120,
	"./playngov2.png": 58780,
	"./playson.svg": 13580,
	"./playsondirec_nfs_1e61f11f-7189-4268-9b8d-99f0fe41c349.svg": 39748,
	"./playsonv4.png": 98822,
	"./playtech_nfs_light_nfs_2c64c310-07dc-4200-8834-6e5552200e75.svg": 77784,
	"./popiplay.svg": 76282,
	"./popiplayv3.svg": 52491,
	"./pragmatic.avif": 48440,
	"./pragmaticexternal.svg": 97883,
	"./pragmaticplay.svg": 82004,
	"./pragmaticplaylive_nfs_5ed52c45-27d9-4e18-8f50-358d54a188c9.svg": 36984,
	"./pragmaticplayv3.webp": 26755,
	"./provider-logos-unified/apollo_play.png": 33554,
	"./provider-logos-unified/aviatrix.png": 81420,
	"./provider-logos-unified/betsoft.png": 14193,
	"./provider-logos-unified/betsolutions.png": 67849,
	"./provider-logos-unified/bgaming.png": 42309,
	"./provider-logos-unified/caleta_games.png": 94002,
	"./provider-logos-unified/el_casino.png": 23679,
	"./provider-logos-unified/evolution.png": 20155,
	"./provider-logos-unified/ezugi.png": 70530,
	"./provider-logos-unified/flatdog_games.png": 21081,
	"./provider-logos-unified/freshdeck.png": 80227,
	"./provider-logos-unified/golden_race.png": 96041,
	"./provider-logos-unified/iconic21.png": 89566,
	"./provider-logos-unified/inout_games.png": 30835,
	"./provider-logos-unified/jacktop_live.png": 1125,
	"./provider-logos-unified/netent.png": 47578,
	"./provider-logos-unified/netgame.png": 29575,
	"./provider-logos-unified/novomatic.png": 614,
	"./provider-logos-unified/pragmatic_play.png": 15235,
	"./provider-logos-unified/red_eagle.png": 66256,
	"./provider-logos-unified/sa_gaming.png": 7560,
	"./provider-logos-unified/salsa_video_bingo.png": 26004,
	"./provider-logos-unified/slotopia.png": 5753,
	"./provider-logos-unified/spinmatic.png": 10798,
	"./provider-logos-unified/superlotto.png": 44343,
	"./provider-logos-unified/tada_gaming.png": 23568,
	"./provider-logos-unified/thunderspin.png": 80654,
	"./provider-logos-unified/triple_cherry.png": 51996,
	"./provider-logos-unified/tvbet.png": 84339,
	"./provider-logos-unified/vibra_gaming.png": 7390,
	"./provider-logos-unified/vivo_gaming.png": 58122,
	"./provider-logos-unified/yggdrasil.png": 5014,
	"./provider-logos-unified/zeusplay.png": 69119,
	"./provider-logos/3oaks.webp": 61422,
	"./provider-logos/7mojo.webp": 58511,
	"./provider-logos/advantplay.webp": 84671,
	"./provider-logos/amusnet.webp": 90448,
	"./provider-logos/apollo_play.webp": 42859,
	"./provider-logos/askmeslot.webp": 58050,
	"./provider-logos/aviatrix.webp": 66713,
	"./provider-logos/betsoft.webp": 93810,
	"./provider-logos/betsolutions.webp": 28570,
	"./provider-logos/better_platform.webp": 20737,
	"./provider-logos/bgaming.webp": 88350,
	"./provider-logos/bigtimegaming.webp": 29283,
	"./provider-logos/blueprint.webp": 35386,
	"./provider-logos/booming.webp": 88700,
	"./provider-logos/caleta_games.webp": 41659,
	"./provider-logos/el_casino.webp": 85508,
	"./provider-logos/endorphina.webp": 68121,
	"./provider-logos/evolution.webp": 55752,
	"./provider-logos/evoplay.webp": 75759,
	"./provider-logos/ezugi.webp": 96267,
	"./provider-logos/flatdog_games.webp": 1034,
	"./provider-logos/freshdeck.webp": 87296,
	"./provider-logos/golden_race.webp": 48717,
	"./provider-logos/habanero.webp": 86303,
	"./provider-logos/hacksaw.webp": 48127,
	"./provider-logos/iconic21.webp": 12207,
	"./provider-logos/inout_games.webp": 19584,
	"./provider-logos/jacktop_live.webp": 23550,
	"./provider-logos/jdb.webp": 2441,
	"./provider-logos/kalamba.webp": 9306,
	"./provider-logos/kingmidas.webp": 170,
	"./provider-logos/mascot_gaming.webp": 50436,
	"./provider-logos/megafair.webp": 76507,
	"./provider-logos/microgaming.webp": 76556,
	"./provider-logos/mrslotty.webp": 35619,
	"./provider-logos/netent.webp": 38675,
	"./provider-logos/netgame.webp": 29308,
	"./provider-logos/nolimitcity.webp": 72436,
	"./provider-logos/novomatic.webp": 2327,
	"./provider-logos/onetouch.webp": 97420,
	"./provider-logos/onlyplay.webp": 72235,
	"./provider-logos/peterandsons.webp": 70105,
	"./provider-logos/pgsoft.webp": 15722,
	"./provider-logos/platipus.webp": 69251,
	"./provider-logos/playngo.webp": 62003,
	"./provider-logos/playson.webp": 68543,
	"./provider-logos/pragmatic_live.webp": 60500,
	"./provider-logos/pragmatic_play.webp": 27424,
	"./provider-logos/pushgaming.webp": 40106,
	"./provider-logos/red_eagle.webp": 27541,
	"./provider-logos/redrake.webp": 54223,
	"./provider-logos/redtiger.webp": 87225,
	"./provider-logos/relax_gaming.webp": 87021,
	"./provider-logos/rubyplay.webp": 22453,
	"./provider-logos/sa_gaming.webp": 70701,
	"./provider-logos/salsa_video_bingo.webp": 51169,
	"./provider-logos/skywind.webp": 25826,
	"./provider-logos/slotopia.webp": 36442,
	"./provider-logos/spade_gaming.webp": 83664,
	"./provider-logos/spinmatic.webp": 43631,
	"./provider-logos/spinomenal.webp": 14465,
	"./provider-logos/spribe.webp": 69120,
	"./provider-logos/superlotto_games.webp": 31320,
	"./provider-logos/tada_gaming.webp": 70965,
	"./provider-logos/thunderspin.webp": 64047,
	"./provider-logos/triple_cherry.webp": 91609,
	"./provider-logos/turbo_games.webp": 41501,
	"./provider-logos/tvbet.webp": 22832,
	"./provider-logos/vibra_gaming.webp": 37471,
	"./provider-logos/vivo_gaming.webp": 27955,
	"./provider-logos/winfinity.webp": 50592,
	"./provider-logos/yellowbat.webp": 47510,
	"./provider-logos/yggdrasil.webp": 68231,
	"./provider-logos/zeusplay.webp": 34228,
	"./provider-placeholder.svg": 25437,
	"./pushgaming.avif": 34397,
	"./quickfire_nfs_7e59ecf2-3573-4826-aaa0-66c411e61fb4.svg": 45242,
	"./quickspin_nfs_93b4eea0-b28e-48cd-a6c6-88ab85bb2d88.svg": 72593,
	"./quickspin_nfs_93b4eea0-b28e-48cd-a6c6-88ab85bb2d88v3.png": 58782,
	"./red-eagle.png": 65528,
	"./redrake.avif": 59002,
	"./redtiger.avif": 31410,
	"./reevo.svg": 32987,
	"./relax.svg": 30524,
	"./relaxv3.svg": 75365,
	"./rubyplay.webp": 64852,
	"./skywind.avif": 90603,
	"./slotmill.svg": 3716,
	"./slotmillv3.png": 43783,
	"./spadegaming.svg": 10906,
	"./spadegamingv3.svg": 59115,
	"./spadegamingv4.png": 94844,
	"./spinmatic.jpeg": 92737,
	"./spinomenal.avif": 34350,
	"./spinomenal.svg": 66740,
	"./spinomenalv3.svg": 39997,
	"./spinomenalv5.png": 76697,
	"./spribe.avif": 68855,
	"./spribe.svg": 30791,
	"./spribev4.png": 86819,
	"./superlotto.svg": 89075,
	"./swintt.svg": 70373,
	"./swinttv3.svg": 77984,
	"./technology.svg": 7116,
	"./thunderkick.svg": 46230,
	"./thunderkickv3.svg": 19535,
	"./thunderkickv4.png": 92124,
	"./tomhornnative.svg": 39252,
	"./truelab.svg": 62411,
	"./turbogames.svg": 62291,
	"./tvbet.png": 14197,
	"./vibra-gaming.png": 68018,
	"./vivogaming.avif": 73399,
	"./voltent.svg": 81062,
	"./wazdan_nfs_78a39601-4f4a-4891-ba95-ed1b7b9cce99.svg": 61908,
	"./wazdan_nfs_78a39601-4f4a-4891-ba95-ed1b7b9cce99v3.png": 82329,
	"./yggdrasil.avif": 71482,
	"./yggdrasil.svg": 18168,
	"./yggdrasilgaming.svg": 72231,
	"./yggdrasilv3.svg": 40057,
	"./zeusplay.svg": 59971,
	"./zillion.svg": 71153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17740;